// Passwords for public preview links, made in the browser (the server keeps only a hash and never sees a generated
// one before it is sent): two common words and a number, easy to read out and type, e.g. "tulip-river-42".
// Contract: flow-helm-chart docs/project-sharing.md ("Password").

const WORDS = [
  'amber', 'anchor', 'apple', 'arrow', 'aspen', 'autumn', 'badge', 'bamboo', 'basil', 'beacon', 'berry', 'birch',
  'bison', 'blossom', 'breeze', 'brook', 'cactus', 'canyon', 'cedar', 'cherry', 'cliff', 'clover', 'cobalt', 'comet',
  'coral', 'cotton', 'crane', 'crystal', 'daisy', 'dawn', 'delta', 'desert', 'dolphin', 'dune', 'eagle', 'ember',
  'falcon', 'fern', 'fjord', 'flint', 'forest', 'fox', 'garnet', 'ginger', 'glacier', 'granite', 'harbor', 'hazel',
  'heron', 'honey', 'island', 'ivory', 'jade', 'jasmine', 'juniper', 'kayak', 'kettle', 'lagoon', 'lantern', 'lemon',
  'lilac', 'linen', 'lotus', 'maple', 'marble', 'meadow', 'mint', 'moss', 'nectar', 'nutmeg', 'oasis', 'olive',
  'onyx', 'orbit', 'orchid', 'otter', 'pebble', 'pepper', 'pine', 'planet', 'plum', 'poppy', 'prairie', 'quartz',
  'quill', 'raven', 'reef', 'ridge', 'river', 'robin', 'saffron', 'sage', 'salmon', 'sequoia', 'shell', 'sierra',
  'silver', 'sparrow', 'spruce', 'stone', 'summit', 'sunset', 'swan', 'thistle', 'thunder', 'tide', 'timber', 'topaz',
  'tulip', 'tundra', 'valley', 'velvet', 'violet', 'walnut', 'willow', 'winter', 'yarrow', 'zephyr',
];

/** A uniformly random integer in [0, max), from the browser's CSPRNG. */
function randomBelow(max) {
  const limit = Math.floor(0x100000000 / max) * max;
  const buffer = new Uint32Array(1);
  do {
    globalThis.crypto.getRandomValues(buffer);
  } while (buffer[0] >= limit);
  return buffer[0] % max;
}

/** A new password like "tulip-river-42" (two different words, a number from 10 to 99). */
export function generateSharePassword() {
  const first = WORDS[randomBelow(WORDS.length)];
  let second = WORDS[randomBelow(WORDS.length)];
  while (second === first) {
    second = WORDS[randomBelow(WORDS.length)];
  }
  return `${first}-${second}-${10 + randomBelow(90)}`;
}

export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 200;

/** What is wrong with a password the person typed, or '' (the server checks the same rules). */
export function sharePasswordProblem(password) {
  if (password.length < PASSWORD_MIN_LENGTH) { return `Use at least ${PASSWORD_MIN_LENGTH} characters.`; }
  if (password.length > PASSWORD_MAX_LENGTH) { return `Use at most ${PASSWORD_MAX_LENGTH} characters.`; }
  if (password.trim() !== password) { return 'A password cannot start or end with a space.'; }
  return '';
}
